export const AREA_LEVEL = {
  administrative_area_level_1: "State",
  administrative_area_level_2: "Region",
  administrative_area_level_3: "City",
  administrative_area_level_4: "Region",
  administrative_area_level_5: "Region",
  colloquial_area: "Area",
  establishment: "Establishment",
  geocode: "Region",
  landmark: "Landmark",
  locality: "City",
  natural_feature: "Natural Feature",
  neighborhood: "Neighborhood",
  point_of_interest: "Point of Interest",
  political: "Region",
  premise: "Premise",
  subpremise: "Premise",
  townsquare: "Town Square",
  sublocality: "City",
  sublocality_level_1: "City",
  sublocality_level_2: "Locality",
  sublocality_level_3: "Locality",
  sublocality_level_4: "Locality",
  sublocality_level_5: "Locality",
}

export const ADMINISTRATIVE_AREA_LEVEL_1 = "administrative_area_level_1"
export const LOCALITY = "locality"
export const COUNTRY = "country"
